import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { communityReviewQueries } from "@circle-react/lib/queries/communityReviews";
import { useQuery } from "react-query";

// Shares the same prompt request/cache entry as useReviewPrompt.
export const useAdminReviewNudge = () => {
  const { currentCommunitySettings, currentCommunityMember } =
    usePunditUserContext();

  const isEnabled =
    !!currentCommunitySettings?.community_reviews_enabled &&
    !!currentCommunityMember?.is_admin;

  return useQuery({
    ...communityReviewQueries.prompt(),
    enabled: isEnabled,
  });
};
